import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { FC } from "react";
import { FieldType } from "./Types";
import React from "react";
import Field from "./Field";
import { ensureHexColor, getNestedProperty } from "./Helpers";
import CustomDataField from "./CustomDataField";

type SectionProps = {
  title: string;
  idx: number | null;
  fields: any[];
  jsonData: any;
  onChange: any;
  fontSizeOptions: any[];
  fontFamilyOptions: any[];
  themeType: string | null;
  fieldsData: any | null;
  fontWeightOptions: any[];
  iconSizeOptions: any[];
  handleCustomDataChange: any;
}

const Section: FC<SectionProps> = (props) => {
  const { title, idx, fields, jsonData, onChange, fontSizeOptions, fontFamilyOptions, fontWeightOptions, iconSizeOptions, themeType, fieldsData, handleCustomDataChange } = props;
  const parsedJsonData = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;

  const getPickerField = (picker: FieldType) => {
    if (picker.hasData) {
      const dataKey = `${picker.card.replace(/\s+/g, '_')}${picker.category ? `-${picker.category.replace(/\s+/g, '_')}` : ''}`;
    
      return (
        <React.Fragment key={`${picker.fieldKey}-${idx}`}>
          {picker?.data?.map((field, index) => {
            const fieldData = fieldsData?.[dataKey]?.find(x => x.FieldKey === field.FieldKey) || {};
            return (
              <Grid key={`${picker.fieldKey}-${index}`} item xs={12} sm={6} md={6} lg={4} xl={3}>
                <CustomDataField
                  picker={picker}
                  data={fieldData}
                  fontWeightOptions={fontWeightOptions}
                  fontSizeOptions={fontSizeOptions}
                  fontFamilyOptions={fontFamilyOptions}
                  iconSizeOptions={iconSizeOptions}
                  handleCustomDataChange={handleCustomDataChange}
                />
              </Grid>
            );
          })}
        </React.Fragment>
      );
    }    

    if (picker.card && picker.category && ((picker.label && (picker.properties.color || picker.properties.fontSize || picker.properties.fontFamily)) || (picker.theme && picker.key))) {
      if (picker.key && picker.theme && parsedJsonData && parsedJsonData?.[picker.theme]?.[picker.key] && Array.isArray(parsedJsonData?.[picker.theme]?.[picker.key])) {
        return (
          <React.Fragment key={`${picker.fieldKey}-${idx}`}>
            {parsedJsonData?.[picker.theme]?.[picker.key].map((x: any, idx: number) => (
              <Grid key={`${picker.fieldKey}-${idx}`} item xs={12} sm={6} md={6} lg={4} xl={3}>
                <Field
                  label={`${picker.label || 'Color'} ${idx + 1}`}
                  colorKey={`${picker.key}.${idx}`}
                  onChange={onChange}
                  themeType={picker.theme}
                  fontSizeOptions={fontSizeOptions}
                  fontFamilyOptions={fontFamilyOptions}
                  initialColor={ensureHexColor(x)}
                  initialFontSize={null}
                  initialFontFamily={null}
                  description={picker.description}
                  fontSizeKey={null}
                  fontFamilyKey={null}
                />
              </Grid>
            ))}
          </React.Fragment>
        );
      } else {
        return (
          <Grid key={`${title}-${picker.fieldKey}`} item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Field
              label={picker.label}
              key={`${picker.key}.${idx}`}
              onChange={onChange}
              themeType={themeType}
              fontSizeOptions={fontSizeOptions}
              fontFamilyOptions={fontFamilyOptions}
              initialColor={getNestedProperty(parsedJsonData, `${themeType}.${picker.properties.color}`)}
              initialFontSize={picker.properties.fontSize ? getNestedProperty(parsedJsonData, `${themeType}.${picker.properties.fontSize}`) : null}
              initialFontFamily={picker.properties.fontFamily ? getNestedProperty(parsedJsonData, `${themeType}.${picker.properties.fontFamily}`) : null}
              description={picker.description}
              colorKey={picker.properties.color}
              fontSizeKey={picker.properties.fontSize}
              fontFamilyKey={picker.properties.fontFamily}
            />
          </Grid>
        );
      }
    }
  };

  return (
    <>
      <Grid sx={{ paddingTop: 2 }} key={`${title}-${idx}`}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMore />} sx={{ marginBottom: 0 }}>
            <Typography variant="h6" gutterBottom sx={{ paddingBottom: 0 }}>
              {title}
              
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={4}>
              {fields?.map((picker) => getPickerField(picker))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  )
};

export default Section;
